import { BaseToolConfig, ToolKind, ToolTrigger } from 'shared/interfaces/tools/Tool';

export enum CustomApiRequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH'
}

export interface RequestConfiguration {
  method: CustomApiRequestMethod;
  urlTemplate: string;
  headersTemplate: Record<string, string>;
  queryParametersTemplate: Record<string, string>;
  bodyTemplate?: string;
}

export interface ResponseHandlingConfiguration {
  successInstruction: string;
  errorInstruction: string;
}

export interface CustomApiRequestToolConfig extends BaseToolConfig {
  kind: ToolKind.CUSTOM_API_REQUEST;
  // toolName is not restricted here since it can be any valid string
  trigger: ToolTrigger.INTENT;
  description: string;
  parametersJsonSchema: string;
  responseHandlingConfiguration: ResponseHandlingConfiguration;
  requestConfiguration: RequestConfiguration;
}

export interface TestCustomApiRequestDto {
  toolConfig: CustomApiRequestToolConfig;
  testParams: Record<string, unknown>;
}

export interface TestCustomApiRequestResultDto {
  status: number;
  executionTimeMs: number;
  formattedResponse: string;
}
